import _ from "underscore";
import {
  FILTER_TYPE_TEXT,
  FILTER_TYPE_INTEGER,
  FILTER_TYPE_MULTISELECT,
  FILTER_TYPE_YESNO,
  FILTER_TYPE_DATE
} from "@/store/system/helpers";
import store from "@/store";
import {
  getSharedSearchFilters as getLcpSearchFilters,
  getSharedBlankCriteria as getLcpBlankCriteria
} from "@/store/levy-collection-providers/helpers";

export function getBlankCriteria() {
  return {
    ...getSharedBlankCriteria(),
    levyCollectionType: [],
    levyCollectionYear: [],
    ...getLcpBlankCriteria()
  };
}

export function getSharedBlankCriteria() {
  return {
    approvedLoanType: [],
    cricosCode: "",
    frliApprovalDateFrom: null,
    frliApprovalDateTo: null,
    hasNotes: null,
    heApplicationStatus: [],
    loanType: [],
    name: "",
    organisationClassification: [],
    organisationOwnership: [],
    providerCode: null,
    revocationReferenceDateFrom: null,
    revocationReferenceDateTo: null,
    rtoCode: "",
    teqsaCode: "",
    vetApplicationStatus: [],
    vslApprovalEndDateFrom: null,
    vslApprovalEndDateTo: null,
    vslApprovalStartDateFrom: null,
    vslApprovalStartDateTo: null
  };
}

export function getSearchFilters() {
  return _(getSharedSearchFilters())
    .chain()
    .union([
      {
        text: "(Levy collection) Type",
        value: "levyCollectionType",
        type: FILTER_TYPE_MULTISELECT,
        items: store.state.lookups.data.levyCollectionTypes,
        default: true
      },
      {
        text: "(Levy collection) Year",
        value: "levyCollectionYear",
        type: FILTER_TYPE_MULTISELECT,
        items: getLevyCollectionYears(),
        default: true
      }
    ])
    .union(getLcpSearchFilters("(Levy collection) "))
    .value();
}

export function getSharedSearchFilters() {
  return [
    // provider details
    { text: "Name (legal or trading)", value: "name", type: FILTER_TYPE_TEXT },
    { text: "Provider code", value: "providerCode", type: FILTER_TYPE_INTEGER },
    { text: "RTO code", value: "rtoCode", type: FILTER_TYPE_TEXT },
    { text: "TEQSA code", value: "teqsaCode", type: FILTER_TYPE_TEXT },
    { text: "CRICOS code", value: "cricosCode", type: FILTER_TYPE_TEXT },
    { text: "Has notes", value: "hasNotes", type: FILTER_TYPE_YESNO },
    {
      text: "Organisation ownership",
      value: "organisationOwnership",
      type: FILTER_TYPE_MULTISELECT,
      items: store.state.lookups.data.organisationOwnerships
    },
    {
      text: "Organisation classification",
      value: "organisationClassification",
      type: FILTER_TYPE_MULTISELECT,
      items: store.state.lookups.data.organisationClassifications
    },
    // provider approvals
    {
      text: "HE application status",
      value: "heApplicationStatus",
      type: FILTER_TYPE_MULTISELECT,
      items: store.state.lookups.data.applicationStatuses
    },
    {
      text: "VET application status",
      value: "vetApplicationStatus",
      type: FILTER_TYPE_MULTISELECT,
      items: store.state.lookups.data.applicationStatuses
    },
    { text: "FRLI approval date on or after", value: "frliApprovalDateFrom", type: FILTER_TYPE_DATE },
    { text: "FRLI approval date on or before", value: "frliApprovalDateTo", type: FILTER_TYPE_DATE },
    { text: "Revocation reference date on or after", value: "revocationReferenceDateFrom", type: FILTER_TYPE_DATE },
    { text: "Revocation reference date on or before", value: "revocationReferenceDateTo", type: FILTER_TYPE_DATE },
    { text: "VSL approval start date on or after", value: "vslApprovalStartDateFrom", type: FILTER_TYPE_DATE },
    { text: "VSL approval start date on or before", value: "vslApprovalStartDateTo", type: FILTER_TYPE_DATE },
    { text: "VSL approval end date on or after", value: "vslApprovalEndDateFrom", type: FILTER_TYPE_DATE },
    { text: "VSL approval end date on or before", value: "vslApprovalEndDateTo", type: FILTER_TYPE_DATE },
    {
      text: "Approved loan type",
      value: "approvedLoanType",
      type: FILTER_TYPE_MULTISELECT,
      items: store.state.lookups.data.loanTypes
    }
  ];
}

function getLevyCollectionYears() {
  if (!store.state.lookups.loaded) return [];
  return _.chain(store.state.lookups.data.allLevyCollections)
    .sortBy(lc => {
      return lc.year;
    })
    .reverse()
    .map(lc => {
      return lc.year;
    })
    .uniq()
    .value()
    .map(v => ({ text: v.toString(), value: v }));
}

export function getBlankRecord() {
  return {
    id: null,
    code: null,
    name: null,
    tradingNames: null,
    rtoCode: null,
    teqsaCode: null,
    cricosCode: null,
    sapCustomerAccounts: [],
    heApplicationStatus: null,
    vetApplicationStatus: null,
    frliApprovalDate: null,
    revocationReferenceDate: null,
    organisationOwnership: null,
    organisationClassification: null,
    approvedLoanTypes: []
  };
}

export function getBlankSapTestingRecord() {
  return {
    sapCustomerAccounts: [],
    hasContactForSapAccount: null
  };
}
